import { Checkbox } from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  createCustomer,
  createStaffCustomer,
  updateCustomer,
} from "../../utils/api";
import useStore from "../../utils/store";
import CustomModal, { ModalInput } from "../Modal";
import SearchableMultiSelect from "./CustomerSearchSelect";

const ClientModal = ({
  open,
  setOpen,
  reload,
  customers,
  update,
  setUpdate,
  groups,
  customer,
  staff,
}) => {
  const [newCustomer, setNewCustomer] = useState({
    access: [],
    isDefaulter: false,
  });

  const user = useStore((state) => state.user);
  console.log(user);

  const [loading, setLoading] = useState(false);
  const createNewCustomer = async () => {
    if (
      !newCustomer.userName ||
      (!newCustomer.password && !customer) ||
      !newCustomer.phoneNumber
    ) {
      toast.error("Please Fill All Fields");
      return;
    }

    if (newCustomer.gstNumber && newCustomer.gstNumber.length !== 15) {
      toast.error("GST Number must be 15 digits if provided");
      return;
    }

    const formdata = new FormData();
    setLoading(true);
    if (!update) {
      if (customer) {
        delete newCustomer.password;
        newCustomer.type = "Customer";
        formdata.append("userName", newCustomer.userName);
        formdata.append("phoneNumber", newCustomer.phoneNumber);
        formdata.append("group", newCustomer.group);
        formdata.append("type", "Customer");
        formdata.append("image", newCustomer.image);
        formdata.append("wagon", newCustomer.wagon);
        formdata.append("isDefaulter", newCustomer.isDefaulter);
        formdata.append("defaulterNote", newCustomer.defaulterNote);
        if (newCustomer.address) {
          formdata.append("address", newCustomer.address);
        }
        if (newCustomer.location) {
          formdata.append("location", newCustomer.location);
        }
        if (newCustomer.gstNumber) {
          formdata.append("gstNumber", newCustomer.gstNumber);
        }
        if (newCustomer.fssai) {
          formdata.append("fssai", newCustomer.fssai);
        }
        if (newCustomer.agency) {
          formdata.append("agency", newCustomer.agency);
        }
        formdata.append("qrCodeEnabled", newCustomer.qrCodeEnabled ? "true" : "false");
        if (newCustomer.qrCodeEnabled) {
          formdata.append("qrLoginUserName", newCustomer.qrLoginUserName || newCustomer.userName || "");
          formdata.append("qrPassword", newCustomer.qrPassword || "");
          formdata.append("password", newCustomer.qrPassword || "");
        }
        if (user?.staff) {
          formdata.append("staffId", user?.staff?._id);
        }
        formdata.append("qrCodeEnabled", newCustomer.qrCodeEnabled ? "true" : "false");
        if (newCustomer.qrCodeEnabled) {
          formdata.append("qrLoginUserName", newCustomer.qrLoginUserName || newCustomer.userName || "");
          formdata.append("qrPassword", newCustomer.qrPassword || "");
          formdata.append("password", newCustomer.qrPassword || "");
        }
      } else {
        newCustomer.type = "Client";
        newCustomer.orderAccess = newCustomer.orderAccess ? true : false;
      }
      const [success, data] =
        user?.admin?.role === "Admin"
          ? await createCustomer(customer ? formdata : newCustomer)
          : await createStaffCustomer(customer ? formdata : newCustomer);
      if (success) {
        setOpen(false);
        setNewCustomer({});
        reload?.();
        toast.success("Customer Created Successfully");
        window.dispatchEvent(new Event("plabel-data-updated"));
        localStorage.setItem("plabel_last_sync", Date.now().toString());
      } else {
        toast.error(data.response.data.message);
      }
    } else {
      const isAdmin = user?.admin?.role === "Admin";
      formdata.append(
        "updatedById",
        isAdmin ? user?.admin?._id : user?.staff?._id
      );
      formdata.append("type", isAdmin ? "admin" : "staff");
      if (customer) {
        formdata.append("userName", newCustomer.userName);
        formdata.append("phoneNumber", newCustomer.phoneNumber);
        // formdata.append("type", "Customer");
        formdata.append("image", newCustomer.image);
        formdata.append("wagon", newCustomer.wagon);
        formdata.append("group", newCustomer.group);
        formdata.append("isDefaulter", newCustomer.isDefaulter);
        formdata.append("defaulterNote", newCustomer.defaulterNote);
        if (newCustomer.address) {
          formdata.append("address", newCustomer.address);
        }
        if (newCustomer.location) {
          formdata.append("location", newCustomer.location);
        }
        if (newCustomer.gstNumber) {
          formdata.append("gstNumber", newCustomer.gstNumber);
        }
        if (newCustomer.fssai) {
          formdata.append("fssai", newCustomer.fssai);
        }
        if (newCustomer.agency) {
          formdata.append("agency", newCustomer.agency);
        }
        formdata.append("qrCodeEnabled", newCustomer.qrCodeEnabled ? "true" : "false");
        if (newCustomer.qrCodeEnabled) {
          formdata.append("qrLoginUserName", newCustomer.qrLoginUserName || newCustomer.userName || "");
          formdata.append("qrPassword", newCustomer.qrPassword || "");
          formdata.append("password", newCustomer.qrPassword || "");
        }
      } else {
        formdata.append("phoneNumber", newCustomer.phoneNumber);
        formdata.append("password", newCustomer.password);
        formdata.append(
          "access",
          JSON.stringify(newCustomer.access?.map((item) => item._id))
        );
        formdata.append("orderAccess", newCustomer.orderAccess);
        formdata.append("isDefaulter", newCustomer.isDefaulter);
        formdata.append("defaulterNote", newCustomer.defaulterNote);
        // formdata.append("type", "Client");
      }

      const [success, data] = await updateCustomer(update._id, formdata);
      if (success) {
        setOpen(false);
        setUpdate(null);
        reload();
        toast.success("Customer Updated Successfully");
      }
    }
    setLoading(false);
  };
  console.log(update);

  React.useEffect(() => {
    if (update) {
      setNewCustomer({
        ...update,
        access: update.access,
        group: update?.group?._id,
        qrCodeEnabled: update?.qrCodeEnabled || false,
        qrLoginUserName: update?.qrLoginUserName || "",
        qrPassword: update?.qrPassword || "",
      });
    }
  }, [update]);

  console.log(!staff, staff);

  return (
    <CustomModal
      open={open}
      setOpen={setOpen}
      onClick={createNewCustomer}
      loading={loading}
    >
      {!staff && (
        <>
          <ModalInput
            title={"USERNAME"}
            onChange={(e) => {
              setNewCustomer({ ...newCustomer, userName: e.target.value });
            }}
            value={newCustomer.userName}
          />
          {customer && (
            <ModalInput
              title={"ADDRESS"}
              onChange={(e) => {
                setNewCustomer({ ...newCustomer, address: e.target.value });
              }}
              value={newCustomer.address}
            />
          )}

          {customer && (
            <ModalInput
              title={"GSTIN"}
              onChange={(e) => {
                setNewCustomer({ ...newCustomer, gstNumber: e.target.value });
              }}
              value={newCustomer.gstNumber}
            />
          )}
          {!customer && (
            <ModalInput
              title={"PASSWORD"}
              onChange={(e) => {
                setNewCustomer({ ...newCustomer, password: e.target.value });
              }}
              value={newCustomer.password}
            />
          )}
          <ModalInput
            title={"Phone Number"}
            onChange={(e) => {
              setNewCustomer({ ...newCustomer, phoneNumber: e.target.value });
            }}
            value={newCustomer.phoneNumber}
          />
        </>
      )}

      {customer && (
        <ModalInput
          title={"LOCATION"}
          onChange={(e) => {
            setNewCustomer({ ...newCustomer, location: e.target.value });
          }}
          value={newCustomer.location}
        />
      )}
      {staff !== "dispatch" && (
        <div className="flex gap-1 md:gap-3 flex-col md:flex-row md:items-center justify-between">
          <label htmlFor={"Group"}>City</label>
          <select
            value={newCustomer.group}
            name={"Group"}
            id={"Group"}
            className={`
       bg-transparent
        border-2 border-black md:w-64 py-1 `}
            onChange={(e) => {
              setNewCustomer({ ...newCustomer, group: e.target.value });
            }}
          >
            <option value="">Select</option>
            {groups?.map((item) => (
              <option key={item._id} value={item._id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      )}

      {customer && (
        <>
          {staff !== "dispatch" && (
            <>
              <ModalInput
                type="file"
                title={"Image"}
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    setNewCustomer({ ...newCustomer, image: e.target.files[0] });
                  }
                }}
              />
              <ModalInput
                type="number"
                title={"Wagon"}
                onChange={(e) => {
                  setNewCustomer({ ...newCustomer, wagon: e.target.value });
                }}
                value={newCustomer.wagon}
              />
              <ModalInput
                type="text"
                title={"FSSAI"}
                value={newCustomer.fssai}
                onChange={(e) => {
                  setNewCustomer({ ...newCustomer, fssai: e.target.value });
                }}
              />
              <ModalInput
                type="text"
                title={"Agency"}
                value={newCustomer.agency}
                onChange={(e) => {
                  setNewCustomer({ ...newCustomer, agency: e.target.value });
                }}
              />
              <div className="flex gap-1 md:gap-3 sitems-center flex-row justify-between ">
                <label htmlFor={"Is Defaulter"}>Is Defaulter</label>

                <Checkbox
                  checked={newCustomer.isDefaulter}
                  onChange={(e) => {
                    setNewCustomer({
                      ...newCustomer,
                      isDefaulter: e.target.checked,
                    });
                  }}
                />
              </div>
              <ModalInput
                type="text"
                title={"Defaulter Note"}
                value={newCustomer.defaulterNote}
                onChange={(e) => {
                  setNewCustomer({
                    ...newCustomer,
                    defaulterNote: e.target.value,
                  });
                }}
              />
              <div className="flex gap-1 md:gap-3 items-center flex-row justify-between bg-emerald-50 p-2.5 rounded-lg border border-emerald-300 my-2">
                <label htmlFor={"QR Code"} className="font-bold text-emerald-950 flex items-center gap-1.5 cursor-pointer text-sm">
                  <span>📱</span> Enable QR Code
                </label>
                <Checkbox
                  checked={Boolean(newCustomer.qrCodeEnabled)}
                  onChange={(e) => {
                    setNewCustomer({
                      ...newCustomer,
                      qrCodeEnabled: e.target.checked,
                      qrLoginUserName: newCustomer.qrLoginUserName || newCustomer.userName || "",
                      qrPassword: newCustomer.qrPassword || "12345678",
                    });
                  }}
                  color="success"
                />
              </div>
              {newCustomer.qrCodeEnabled && (
                <div className="flex flex-col gap-2 p-2.5 bg-emerald-50 rounded-lg border border-emerald-200 mb-2">
                  <ModalInput
                    type="text"
                    title={"QR Username"}
                    placeholder={"Enter username for customer login"}
                    value={newCustomer.qrLoginUserName ?? ""}
                    onChange={(e) => {
                      setNewCustomer({
                        ...newCustomer,
                        qrLoginUserName: e.target.value,
                      });
                    }}
                  />
                  <ModalInput
                    type="text"
                    title={"QR Password"}
                    placeholder={"Enter password for customer login"}
                    value={newCustomer.qrPassword ?? ""}
                    onChange={(e) => {
                      setNewCustomer({
                        ...newCustomer,
                        qrPassword: e.target.value,
                      });
                    }}
                  />
                </div>
              )}
              
            </>
          )}
        </>
      )}

      {!customer && (
        <>
          <SearchableMultiSelect
            value={newCustomer.access}
            onChange={(e) => {
              setNewCustomer({ ...newCustomer, access: e });
            }}
          />
          <div className="flex gap-1 md:gap-3 sitems-center flex-row justify-between ">
            <label htmlFor={"Order Access"}>Order Access</label>

            <Checkbox
              checked={newCustomer.orderAccess}
              onChange={(e) => {
                setNewCustomer({
                  ...newCustomer,
                  orderAccess: e.target.checked,
                });
              }}
            />
          </div>
        </>
      )}
    </CustomModal>
  );
};

export default ClientModal;
